import { Box } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { TaskDynamicFormCol } from "./TaskDynamicFormCol";
import { TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

//Expression Functions
//***************************************************************
const globalPointer = window as any;

globalPointer.minutesToDateStr = (minutes: number) => Base.minutesToDateStr(minutes);

globalPointer.utcDateAndTimeDiffInMinutes = (date1: Date, time1: Date, date2: Date, time2: Date) => Base.utcDateAndTimeDiffInMinutes(date1, time1, date2, time2);

globalPointer.utcDateAndTimeDiffInTimeSpan = (date1: Date, time1: Date, date2: Date, time2: Date) => Base.utcDateAndTimeDiffInTimeSpan(date1, time1, date2, time2);

//TaskDynamicForm
//***************************************************************
export interface ITaskDynamicFormProp {
    isReadOnly?: boolean;
    mobile?: boolean;
    preview?: boolean;
    isEdit?: boolean;
    taskTypeCols: ITaskTypeCol[];
    taskDataRowCols: ITaskDataRowCol[];
    taskDataRowColsOrg?: ITaskDataRowCol[];
    selectedField?: string;
    onRefreshCols: (taskDataRowCols: ITaskDataRowCol[]) => void;
    onComponentClick?: (field: string) => void;
}

export interface ITaskDynamicFormState {
    readOnlyColfields: string[];
}

export class TaskDynamicForm extends React.Component<ITaskDynamicFormProp, ITaskDynamicFormState> {
    constructor(props: ITaskDynamicFormProp) {
        super(props);
        this.state = {
            readOnlyColfields: TaskEditTypeItem.evaluateColsReadOnlyExpressions(props.taskDataRowCols, props.taskTypeCols)
        };
    }

    componentDidUpdate(prevProps: ITaskDynamicFormProp, prevState: ITaskDynamicFormState) {
        const props = this.props;
        if (JSON.stringify(prevProps.taskDataRowCols) === JSON.stringify(props.taskDataRowCols)) return;
        const readOnlyColfields = TaskEditTypeItem.evaluateColsReadOnlyExpressions(props.taskDataRowCols, props.taskTypeCols);
        if (JSON.stringify(prevState.readOnlyColfields) === JSON.stringify(readOnlyColfields)) return;
        this.setState({
            readOnlyColfields
        });
    }

    handleValueChange = (dataCol: ITaskDataRowCol) => {
        if (Base.isNullOrUndefined(dataCol)) return;
        const props = this.props;
        const taskDataRowCols = props.taskDataRowCols.slice(0);
        const taskDataRowCol = taskDataRowCols.find(i => i.field === dataCol.field);
        taskDataRowCol.valueStr = dataCol?.valueStr || "";
        taskDataRowCol.valueNbr = dataCol.valueNbr;
        TaskEditTypeItem.evaluateColsExpressions(taskDataRowCols, props.taskTypeCols);
        const clearFields = TaskEditTypeItem.evaluateColsClearExpressions(taskDataRowCols, props.taskTypeCols);
        for (const clearField of clearFields) {
            const clearDataColIndex = taskDataRowCols.findIndex(i => i.field === clearField);
            if (clearDataColIndex < 0) continue;
            const taskTypeCol = props.taskTypeCols.find(i => i.field === clearField);
            if (!taskTypeCol) continue;
            taskDataRowCols[clearDataColIndex] = TaskDataRowCol.getDefaultValueTaskDataRowCol(taskTypeCol);
        }
        this.setState({
            readOnlyColfields: TaskEditTypeItem.evaluateColsReadOnlyExpressions(props.taskDataRowCols, props.taskTypeCols)
        });
        props.onRefreshCols(taskDataRowCols);
    };

    render() {
        const props = this.props;
        const taskTypeCols = props.taskTypeCols;
        if (!taskTypeCols) return null;
        return (
            <div className={"jsonFormData col-12" + (props.mobile ? " mobileSimulation" : "")}>
                <div className="row">
                    {taskTypeCols.map((taskTypeCol) => {
                        const showInPreview = props.preview && !!props.onComponentClick;
                        const showSelectionInPreview = showInPreview && props.selectedField === taskTypeCol.field;
                        const colComponent = <TaskDynamicFormCol
                            key={taskTypeCol.field}
                            isReadOnly={props.isReadOnly}
                            colIsReadOnly={taskTypeCol.readOnly || this.state.readOnlyColfields.indexOf(taskTypeCol.field) > -1}
                            taskTypeCol={taskTypeCol}
                            taskDataRowCol={props.taskDataRowCols.find(i => i.field === taskTypeCol.field)}
                            taskDataRowColOrg={props.taskDataRowColsOrg?.find(i => i.field === taskTypeCol.field)}
                            ignoreClass={showInPreview}
                            isEdit={props.isEdit}
                            onChange={this.handleValueChange}
                        />;
                        return !showInPreview
                            ? colComponent
                            : <Box
                                key={taskTypeCol.field}
                                className={"col " + (!Base.isNullOrEmpty(taskTypeCol.class) ? taskTypeCol.class : "")}
                                onClick={() => props.onComponentClick(taskTypeCol.field)}
                            >
                                {(showSelectionInPreview
                                    ? <Box
                                        sx={{
                                            border: "4px dashed",
                                            borderColor: "text.secondary",
                                            margin: "-4px -9px",
                                            padding: "0 5px",
                                        }}
                                        onClick={() => props.onComponentClick(taskTypeCol.field)}
                                    >
                                        {colComponent}
                                    </Box>
                                    : colComponent
                                )}
                            </Box>;
                    })}
                </div>
            </div>
        );
    }
}